import { render, staticRenderFns } from "./datamodel.vue?vue&type=template&id=5fc71d1c"
import script from "./datamodel.vue?vue&type=script&lang=js"
export * from "./datamodel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports